export default "__VITE_ASSET__f892146d__"